export type SectionOneActionKey =
  | "view"
  | "sendToSign"
  | "rejectSign"
  | "rollback"
  | "edit"
  | "versions"
  | "delete";

export const getSectionOneActions = (
  status?: string,
  hasVersion?: boolean,
): SectionOneActionKey[] => {
  switch (status) {
    case "NEW":
      return ["view", "sendToSign", "edit", "delete"] as SectionOneActionKey[];
    case "AWAITING_SIGNATURE":
      return ["view", "rejectSign"] as SectionOneActionKey[];
    case "REJECTED":
      // For REJECTED we only allow view and rollback (as in the table)
      return ["view", "rollback"] as SectionOneActionKey[];
    case "SIGNED":
      // For SIGNED always show versions (table shows it regardless)
      return (["view", "edit", "versions"]) as SectionOneActionKey[];
    case "SENT_TO_GSN":
    case "SEND_TO_GSN":
      return (["view", "versions"]) as SectionOneActionKey[];
    default:
      return (["view", ...(hasVersion ? (["versions"] as SectionOneActionKey[]) : [])]) as SectionOneActionKey[];
  }
};


